var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3042 8.26053V6.26053C14.3042 5.7301 14.0935 5.22139 13.7184 4.84631C13.3433 4.47124 12.8346 4.26053 12.3042 4.26053H5.3042C4.77377 4.26053 4.26506 4.47124 3.88999 4.84631C3.51491 5.22139 3.3042 5.7301 3.3042 6.26053V18.2605C3.3042 18.791 3.51491 19.2997 3.88999 19.6747C4.26506 20.0498 4.77377 20.2605 5.3042 20.2605H12.3042C12.8346 20.2605 13.3433 20.0498 13.7184 19.6747C14.0935 19.2997 14.3042 18.791 14.3042 18.2605V16.2605",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3042 12.2605H21.3042M21.3042 12.2605L18.3042 9.26053M21.3042 12.2605L18.3042 15.2605",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.d879d249b003b63dcfd0152c23f95271.svg";
export { ForwardRef as ReactComponent };